import { render, staticRenderFns } from "./CardTarjaCopaAmericaFutebol.vue?vue&type=template&id=02e4a958&scoped=true"
import script from "./CardTarjaCopaAmericaFutebol.vue?vue&type=script&lang=js"
export * from "./CardTarjaCopaAmericaFutebol.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaCopaAmericaFutebol.vue?vue&type=style&index=0&id=02e4a958&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e4a958",
  null
  
)

export default component.exports